import { render, staticRenderFns } from "./ApplicationTokenDetails.vue?vue&type=template&id=06dc9c58&"
import script from "./ApplicationTokenDetails.vue?vue&type=script&lang=js&"
export * from "./ApplicationTokenDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports